module.exports = __webpack_public_path__ + "img/monitor.5d2f2341.svg";